unit EventViewerListPage;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  BaseList,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  Data.DB,
  WEBLib.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  Vcl.Controls,
  WEBLib.Lists,
  smx.webcore.types;

type
  TEventViewerListForm = class(TBaseListForm)
    MainDatasetId: TIntegerField;
    MainDatasetDateAdded: TDateTimeField;
    MainDatasetAddedBy: TIntegerField;
    MainDatasetLastUpdatedBy: TIntegerField;
    MainDatasetLastUpdated: TDateTimeField;
    MainDatasetJobType: TStringField;
    MainDatasetSubmittedBy: TIntegerField;
    MainDatasetDateSubmitted: TDateTimeField;
    MainDatasetStatus: TStringField;
    MainDatasetTimeTaken: TFloatField;
    MainDatasetDateRun: TDateTimeField;
    MainDatasetVisibility: TStringField;
    MainDatasetData: TStringField;
    MainDatasetStats: TStringField;
    MainDatasetDownloads: TStringField;
    MainDatasetOutputOption: TStringField;
    MainDatasetCompletedBy: TIntegerField;
    MainDatasetOwnedBy: TIntegerField;
    MainDatasetTitle: TStringField;
    MainDatasetNotifyOnCompletion: TBooleanField;
    MainDatasetDateCompleted: TDateTimeField;
    MainDatasetHasErrors: TBooleanField;
    MainDatasetProgress: TFloatField;
    MainDatasetRunLevel: TStringField;
    MainDatasetJobCategory: TStringField;
    MainDatasetLastPolled: TDateTimeField;
    MainDatasetPollInterval: TLargeintField;
    MainDatasetPollCount: TIntegerField;
    MainDatasetIsRunning: TBooleanField;
    ResetFailedButton: TButton;
    procedure WebFormShow(Sender: TObject);
    procedure DataTableGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
    procedure ResetFailedButtonClick(Sender: TObject);
    procedure DataTableGetCellChildren(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
  private
    { Private declarations }

    [async]
    procedure ResetFailedJobs; async;

    [async]
    procedure ResetJob(const AJobId: string); async;

  protected
    procedure PrepareForm; override;

    procedure LoadData; override;

    [async]
    procedure EditRecord(const ARecordId: string); async; override;

    [async]
    procedure DeleteRecord(const ARecordId: string); async;

    function InitSortCol: Integer; override;
    function InitSortDirection: TSortDirection; override;

    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement); override;

  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  EventViewerListForm: TEventViewerListForm;

implementation

{$R *.dfm}

uses
  MainDataModule,
  EventViewerEditPage,
  XData.Web.Client,
  smx.Web.Layout.Utils,
  Web.Json.Utils,
  Weblib.webctrls;

procedure TEventViewerListForm.PrepareForm;
begin
  FIdField := 'Id';

  MainDataset.Connection := MainData.DataConnection;

end;

procedure TEventViewerListForm.ResetFailedButtonClick(Sender: TObject);
begin
  inherited;

  ResetFailedJobs;

end;

procedure TEventViewerListForm.ResetFailedJobs;
const
  SC_ResetJobs = 'IJobsService.ResetFailedJobs';

var
  oClientResponse: TXDataClientResponse;
  jsoResponse: TJSObject;
  sMessage: string;
  bSuccess: Boolean;

begin
  inherited;

  oClientResponse := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_ResetJobs,
      [ ]
    )
  );
  jsoResponse := oClientResponse.ResultAsObject;
  bSuccess := Boolean(jsoResponse['value']);

  if bSuccess then
    sMessage := 'Jobs reset successfully'
  else
    sMessage := 'Failed to reset jobs';

  ShowMessage(sMessage);

  StandardLoadData;

end;

procedure TEventViewerListForm.WebFormShow(Sender: TObject);
begin
  inherited;
  cbPageSizeChange(cbPageSize);

  AddButton.ElementHandle.hidden := True;

end;

procedure TEventViewerListForm.LoadData;
begin
  StandardLoadData;

end;

procedure TEventViewerListForm.DataTableGetCellChildren(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
begin
  inherited;

  if Sender is TDBTableControl then
  begin
    // hide first column
    if ACol = 0 then
    begin
      AElement.Element.style.setProperty('display', 'none');

    end;

    // fix column width for data field
    if TDBTableControl(Sender).Columns[ACol].DataField = 'Data' then
    begin
      AElement.Element.style.setProperty('overflow', 'hidden');
      AElement.Element.style.setProperty('text-overflow', 'ellipsis');
      AElement.Element.style.setProperty('white-space', 'nowrap');
      AElement.Element.style.setProperty('max-width', '500px');
      AElement.Element.style.setProperty('display', 'block'); // Ensure max-width applies

    end;

  end;

end;

procedure TEventViewerListForm.DataTableGetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);

begin
  inherited;

  if Sender is TDBTableControl then
  begin
    if TDBTableControl(Sender).Columns[ACol].DataField = 'Stats' then
    begin
      if Assigned(AField) then
      begin
        if AField.IsNull then
          AValue := ''
        else
          AValue := FormatJobStatsDisplayLine(string(AField.Value));

      end
      else
      begin
        // don't clear header row
        if ARow <> 0 then
          AValue := '';

      end;

    end;

  end;

end;

procedure TEventViewerListForm.EditRecord(const ARecordId: string);
var
  AForm: TEventViewerEditForm;
  bReload: Boolean;

begin
  if ARecordId = ''  then
    MainDataset.Append
  else
    MainDataset.Locate('Id', ARecordId.ToInteger, []);

  AForm := TEventViewerEditForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.IdField := FIdField;

    Await(TEventViewerEditForm, AForm.Load());
    Await(AForm.InitForm);

    AForm.Dataset := MainDataset;

    Await(TModalResult, AForm.Execute);

    bReload := AForm.IsReloadRequired;

  finally
    AForm.Free;
    AForm := nil;

  end;

  if bReload then
    StandardLoadData;

end;

function TEventViewerListForm.InitSortCol: Integer;
begin
  // default sorting by first column
  Result := 1;

end;

function TEventViewerListForm.InitSortDirection: TSortDirection;
begin
  // default to descending sort order
  Result := sdAsc;

end;

procedure TEventViewerListForm.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);

  procedure EditClick(Sender: TObject);
  begin
    EditRecord(ARecordId);

  end;

  procedure DeleteClick(Sender: TObject);
  begin
    DeleteRecord(ARecordId);

  end;

  procedure ResetClick(Sender: TObject);
  begin
    ResetJob(ARecordId);

  end;

var
  Span: THTMLSpan;
begin
  if (RecordViewOption in [voEdit, voCreateAndEdit]) then
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-eye', 'View');
    Span.OnClick := @EditClick;

    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-trash', 'Delete');
    Span.OnClick := @DeleteClick;
    if ARecordId = '' then
      Span.Hide;

    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-redo', 'Reset');
    Span.OnClick := @ResetClick;
    if ARecordId = '' then
      Span.Hide;

  end
  else if RecordViewOption = voReadOnly then
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-eye', 'View');
    Span.OnClick := @EditClick;

    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-redo', 'Reset');
    Span.OnClick := @ResetClick;
    if ARecordId = '' then
      Span.Hide;

  end;

end;

procedure TEventViewerListForm.DeleteRecord(const ARecordId: string);
const
  SC_SetJobStatusNothingToDo = 'IJobsService.SetJobStatusNothingToDo';

var
  oClientResponse: TXDataClientResponse;
  jsoResponse: TJSObject;
  bSuccess: Boolean;
  sMessage: string;

begin
  if ARecordId = ''  then
    Exit;

  inherited;

  oClientResponse := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_SetJobStatusNothingToDo,
      [ StrToInt(ARecordId) ]
    )
  );
  jsoResponse := oClientResponse.ResultAsObject;
  bSuccess := JS.toBoolean(jsoResponse['value']);

  if bSuccess then
    sMessage := 'Job removed successfully'
  else
    sMessage := 'Failed to remove job';

  ShowMessage(sMessage);

  if bSuccess then
    StandardLoadData;

end;

procedure TEventViewerListForm.ResetJob(const AJobId: string);
const
  SC_ResetJob = 'IJobsService.ResetJob';

var
  oClientResponse: TXDataClientResponse;
  jsoResponse: TJSObject;
  bSuccess: Boolean;
  sMessage: string;

begin
  if AJobId = '' then
    Exit;

  oClientResponse := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_ResetJob,
      [ StrToInt(AJobId) ]
    )
  );
  jsoResponse := oClientResponse.ResultAsObject;
  bSuccess := JS.toBoolean(jsoResponse['value']);

  if bSuccess then
    sMessage := 'Job reset successfully'
  else
    sMessage := 'Failed to reset job';

  ShowMessage(sMessage);

  if bSuccess then
    StandardLoadData;

end;

procedure TEventViewerListForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  ResetFailedButton := TButton.Create('reset-failed');
  MainDatasetId := TIntegerField.Create(Self);
  MainDatasetDateAdded := TDateTimeField.Create(Self);
  MainDatasetAddedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdatedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdated := TDateTimeField.Create(Self);
  MainDatasetJobType := TStringField.Create(Self);
  MainDatasetSubmittedBy := TIntegerField.Create(Self);
  MainDatasetDateSubmitted := TDateTimeField.Create(Self);
  MainDatasetStatus := TStringField.Create(Self);
  MainDatasetTimeTaken := TFloatField.Create(Self);
  MainDatasetDateRun := TDateTimeField.Create(Self);
  MainDatasetVisibility := TStringField.Create(Self);
  MainDatasetData := TStringField.Create(Self);
  MainDatasetStats := TStringField.Create(Self);
  MainDatasetDownloads := TStringField.Create(Self);
  MainDatasetOutputOption := TStringField.Create(Self);
  MainDatasetCompletedBy := TIntegerField.Create(Self);
  MainDatasetOwnedBy := TIntegerField.Create(Self);
  MainDatasetTitle := TStringField.Create(Self);
  MainDatasetNotifyOnCompletion := TBooleanField.Create(Self);
  MainDatasetDateCompleted := TDateTimeField.Create(Self);
  MainDatasetHasErrors := TBooleanField.Create(Self);
  MainDatasetProgress := TFloatField.Create(Self);
  MainDatasetRunLevel := TStringField.Create(Self);
  MainDatasetJobCategory := TStringField.Create(Self);
  MainDatasetLastPolled := TDateTimeField.Create(Self);
  MainDatasetPollInterval := TLargeintField.Create(Self);
  MainDatasetPollCount := TIntegerField.Create(Self);
  MainDatasetIsRunning := TBooleanField.Create(Self);

  DataTable.BeforeLoadDFMValues;
  AddButton.BeforeLoadDFMValues;
  ResetFailedButton.BeforeLoadDFMValues;
  MainDataset.BeforeLoadDFMValues;
  MainDatasetId.BeforeLoadDFMValues;
  MainDatasetDateAdded.BeforeLoadDFMValues;
  MainDatasetAddedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdatedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdated.BeforeLoadDFMValues;
  MainDatasetJobType.BeforeLoadDFMValues;
  MainDatasetSubmittedBy.BeforeLoadDFMValues;
  MainDatasetDateSubmitted.BeforeLoadDFMValues;
  MainDatasetStatus.BeforeLoadDFMValues;
  MainDatasetTimeTaken.BeforeLoadDFMValues;
  MainDatasetDateRun.BeforeLoadDFMValues;
  MainDatasetVisibility.BeforeLoadDFMValues;
  MainDatasetData.BeforeLoadDFMValues;
  MainDatasetStats.BeforeLoadDFMValues;
  MainDatasetDownloads.BeforeLoadDFMValues;
  MainDatasetOutputOption.BeforeLoadDFMValues;
  MainDatasetCompletedBy.BeforeLoadDFMValues;
  MainDatasetOwnedBy.BeforeLoadDFMValues;
  MainDatasetTitle.BeforeLoadDFMValues;
  MainDatasetNotifyOnCompletion.BeforeLoadDFMValues;
  MainDatasetDateCompleted.BeforeLoadDFMValues;
  MainDatasetHasErrors.BeforeLoadDFMValues;
  MainDatasetProgress.BeforeLoadDFMValues;
  MainDatasetRunLevel.BeforeLoadDFMValues;
  MainDatasetJobCategory.BeforeLoadDFMValues;
  MainDatasetLastPolled.BeforeLoadDFMValues;
  MainDatasetPollInterval.BeforeLoadDFMValues;
  MainDatasetPollCount.BeforeLoadDFMValues;
  MainDatasetIsRunning.BeforeLoadDFMValues;
  try
    Name := 'EventViewerListForm';
    Caption := 'Event Viewer List';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    DataTable.Top := 110;
    DataTable.WidthStyle := ssPercent;
    DataTable.WordWrap := True;
    SetEvent(DataTable, Self, 'OnGetCellData', 'DataTableGetCellData');
    DataTable.Columns.Clear;
    with DataTable.Columns.Add do
    begin
      DataField := 'Id';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'DateSubmitted';
      Title := 'Submitted';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'Stats';
      Title := 'Stats';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'Status';
      Title := 'Status';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'Data';
      Title := 'Data';
    end;
    with DataTable.Columns.Add do
    begin
      Title := 'Actions';
      Width := 250;
    end;
    AddButton.Visible := False;
    ResetFailedButton.SetParentComponent(Self);
    ResetFailedButton.Name := 'ResetFailedButton';
    ResetFailedButton.Left := 296;
    ResetFailedButton.Top := 408;
    ResetFailedButton.Width := 96;
    ResetFailedButton.Height := 25;
    ResetFailedButton.Caption := 'Reset All';
    ResetFailedButton.ChildOrder := 9;
    ResetFailedButton.ElementClassName := 'btn btn-light';
    ResetFailedButton.ElementFont := efCSS;
    ResetFailedButton.ElementPosition := epIgnore;
    ResetFailedButton.HeightStyle := ssAuto;
    ResetFailedButton.HeightPercent := 100.000000000000000000;
    ResetFailedButton.WidthStyle := ssAuto;
    ResetFailedButton.WidthPercent := 100.000000000000000000;
    SetEvent(ResetFailedButton, Self, 'OnClick', 'ResetFailedButtonClick');
    MainDataset.Filtered := True;
    MainDataset.EntitySetName := 'Job';
    MainDataset.QueryString := '$filter= Status eq '#39'Failed'#39;
    MainDatasetId.SetParentComponent(MainDataset);
    MainDatasetId.Name := 'MainDatasetId';
    MainDatasetId.FieldName := 'Id';
    MainDatasetId.Required := True;
    MainDatasetDateAdded.SetParentComponent(MainDataset);
    MainDatasetDateAdded.Name := 'MainDatasetDateAdded';
    MainDatasetDateAdded.FieldName := 'DateAdded';
    MainDatasetDateAdded.Required := True;
    MainDatasetAddedBy.SetParentComponent(MainDataset);
    MainDatasetAddedBy.Name := 'MainDatasetAddedBy';
    MainDatasetAddedBy.FieldName := 'AddedBy';
    MainDatasetAddedBy.Required := True;
    MainDatasetLastUpdatedBy.SetParentComponent(MainDataset);
    MainDatasetLastUpdatedBy.Name := 'MainDatasetLastUpdatedBy';
    MainDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    MainDatasetLastUpdated.SetParentComponent(MainDataset);
    MainDatasetLastUpdated.Name := 'MainDatasetLastUpdated';
    MainDatasetLastUpdated.FieldName := 'LastUpdated';
    MainDatasetJobType.SetParentComponent(MainDataset);
    MainDatasetJobType.Name := 'MainDatasetJobType';
    MainDatasetJobType.FieldName := 'JobType';
    MainDatasetJobType.Size := 25;
    MainDatasetSubmittedBy.SetParentComponent(MainDataset);
    MainDatasetSubmittedBy.Name := 'MainDatasetSubmittedBy';
    MainDatasetSubmittedBy.FieldName := 'SubmittedBy';
    MainDatasetDateSubmitted.SetParentComponent(MainDataset);
    MainDatasetDateSubmitted.Name := 'MainDatasetDateSubmitted';
    MainDatasetDateSubmitted.FieldName := 'DateSubmitted';
    MainDatasetStatus.SetParentComponent(MainDataset);
    MainDatasetStatus.Name := 'MainDatasetStatus';
    MainDatasetStatus.FieldName := 'Status';
    MainDatasetStatus.Size := 16;
    MainDatasetTimeTaken.SetParentComponent(MainDataset);
    MainDatasetTimeTaken.Name := 'MainDatasetTimeTaken';
    MainDatasetTimeTaken.FieldName := 'TimeTaken';
    MainDatasetDateRun.SetParentComponent(MainDataset);
    MainDatasetDateRun.Name := 'MainDatasetDateRun';
    MainDatasetDateRun.FieldName := 'DateRun';
    MainDatasetVisibility.SetParentComponent(MainDataset);
    MainDatasetVisibility.Name := 'MainDatasetVisibility';
    MainDatasetVisibility.FieldName := 'Visibility';
    MainDatasetVisibility.Size := 16;
    MainDatasetData.SetParentComponent(MainDataset);
    MainDatasetData.Name := 'MainDatasetData';
    MainDatasetData.FieldName := 'Data';
    MainDatasetData.Size := 4096;
    MainDatasetStats.SetParentComponent(MainDataset);
    MainDatasetStats.Name := 'MainDatasetStats';
    MainDatasetStats.FieldName := 'Stats';
    MainDatasetStats.Size := 4096;
    MainDatasetDownloads.SetParentComponent(MainDataset);
    MainDatasetDownloads.Name := 'MainDatasetDownloads';
    MainDatasetDownloads.FieldName := 'Downloads';
    MainDatasetDownloads.Size := 4096;
    MainDatasetOutputOption.SetParentComponent(MainDataset);
    MainDatasetOutputOption.Name := 'MainDatasetOutputOption';
    MainDatasetOutputOption.FieldName := 'OutputOption';
    MainDatasetOutputOption.Size := 50;
    MainDatasetCompletedBy.SetParentComponent(MainDataset);
    MainDatasetCompletedBy.Name := 'MainDatasetCompletedBy';
    MainDatasetCompletedBy.FieldName := 'CompletedBy';
    MainDatasetOwnedBy.SetParentComponent(MainDataset);
    MainDatasetOwnedBy.Name := 'MainDatasetOwnedBy';
    MainDatasetOwnedBy.FieldName := 'OwnedBy';
    MainDatasetTitle.SetParentComponent(MainDataset);
    MainDatasetTitle.Name := 'MainDatasetTitle';
    MainDatasetTitle.FieldName := 'Title';
    MainDatasetTitle.Size := 255;
    MainDatasetNotifyOnCompletion.SetParentComponent(MainDataset);
    MainDatasetNotifyOnCompletion.Name := 'MainDatasetNotifyOnCompletion';
    MainDatasetNotifyOnCompletion.FieldName := 'NotifyOnCompletion';
    MainDatasetDateCompleted.SetParentComponent(MainDataset);
    MainDatasetDateCompleted.Name := 'MainDatasetDateCompleted';
    MainDatasetDateCompleted.FieldName := 'DateCompleted';
    MainDatasetHasErrors.SetParentComponent(MainDataset);
    MainDatasetHasErrors.Name := 'MainDatasetHasErrors';
    MainDatasetHasErrors.FieldName := 'HasErrors';
    MainDatasetProgress.SetParentComponent(MainDataset);
    MainDatasetProgress.Name := 'MainDatasetProgress';
    MainDatasetProgress.FieldName := 'Progress';
    MainDatasetRunLevel.SetParentComponent(MainDataset);
    MainDatasetRunLevel.Name := 'MainDatasetRunLevel';
    MainDatasetRunLevel.FieldName := 'RunLevel';
    MainDatasetRunLevel.Size := 10;
    MainDatasetJobCategory.SetParentComponent(MainDataset);
    MainDatasetJobCategory.Name := 'MainDatasetJobCategory';
    MainDatasetJobCategory.FieldName := 'JobCategory';
    MainDatasetJobCategory.Size := 8;
    MainDatasetLastPolled.SetParentComponent(MainDataset);
    MainDatasetLastPolled.Name := 'MainDatasetLastPolled';
    MainDatasetLastPolled.FieldName := 'LastPolled';
    MainDatasetPollInterval.SetParentComponent(MainDataset);
    MainDatasetPollInterval.Name := 'MainDatasetPollInterval';
    MainDatasetPollInterval.FieldName := 'PollInterval';
    MainDatasetPollCount.SetParentComponent(MainDataset);
    MainDatasetPollCount.Name := 'MainDatasetPollCount';
    MainDatasetPollCount.FieldName := 'PollCount';
    MainDatasetIsRunning.SetParentComponent(MainDataset);
    MainDatasetIsRunning.Name := 'MainDatasetIsRunning';
    MainDatasetIsRunning.FieldName := 'IsRunning';
  finally
    DataTable.AfterLoadDFMValues;
    AddButton.AfterLoadDFMValues;
    ResetFailedButton.AfterLoadDFMValues;
    MainDataset.AfterLoadDFMValues;
    MainDatasetId.AfterLoadDFMValues;
    MainDatasetDateAdded.AfterLoadDFMValues;
    MainDatasetAddedBy.AfterLoadDFMValues;
    MainDatasetLastUpdatedBy.AfterLoadDFMValues;
    MainDatasetLastUpdated.AfterLoadDFMValues;
    MainDatasetJobType.AfterLoadDFMValues;
    MainDatasetSubmittedBy.AfterLoadDFMValues;
    MainDatasetDateSubmitted.AfterLoadDFMValues;
    MainDatasetStatus.AfterLoadDFMValues;
    MainDatasetTimeTaken.AfterLoadDFMValues;
    MainDatasetDateRun.AfterLoadDFMValues;
    MainDatasetVisibility.AfterLoadDFMValues;
    MainDatasetData.AfterLoadDFMValues;
    MainDatasetStats.AfterLoadDFMValues;
    MainDatasetDownloads.AfterLoadDFMValues;
    MainDatasetOutputOption.AfterLoadDFMValues;
    MainDatasetCompletedBy.AfterLoadDFMValues;
    MainDatasetOwnedBy.AfterLoadDFMValues;
    MainDatasetTitle.AfterLoadDFMValues;
    MainDatasetNotifyOnCompletion.AfterLoadDFMValues;
    MainDatasetDateCompleted.AfterLoadDFMValues;
    MainDatasetHasErrors.AfterLoadDFMValues;
    MainDatasetProgress.AfterLoadDFMValues;
    MainDatasetRunLevel.AfterLoadDFMValues;
    MainDatasetJobCategory.AfterLoadDFMValues;
    MainDatasetLastPolled.AfterLoadDFMValues;
    MainDatasetPollInterval.AfterLoadDFMValues;
    MainDatasetPollCount.AfterLoadDFMValues;
    MainDatasetIsRunning.AfterLoadDFMValues;
  end;
end;

end.